<div class="view-dialog-container" *ngIf="form">
    <div class="header-container">
        <div class="header-title">Assign teachers</div>
        <div class="cros-icon" (click)="onCancel()">
            <img src="assets/images/cross-icon.svg" class="cross-icon" />
        </div>
    </div>

    <form [formGroup]="form" class="d-grid" *ngIf="!loading">
        <div class="head-text">
            {{schoolName}}
        </div>
        <div class="profile-scroll">
            <!-- Search Teachers Input -->
            <div class="form-group">
                <!-- Custom Select Component -->
                <div class="custom-select-container">
                    <div class="custom-select-wrapper">
                        <div class="search-input-container">
                            <!-- <input type="text" class="search-input" placeholder="Search teachers by name or email"
                                [(ngModel)]="searchText" (input)="filterTeachers()" (focus)="openDropdown()"
                                [ngModelOptions]="{standalone: false}"> -->
                            <input type="text" class="search-input" placeholder="Search teachers by name or email"
                                [(ngModel)]="searchText" [ngModelOptions]="{ standalone: true }"
                                (input)="filterTeachers()" (focus)="handleInputFocus($event)" #searchInput />

                        </div>

                        <div class="custom-select-dropdown" *ngIf="isDropdownOpen">
                            <div class="dropdown-options">
                                <div *ngFor="let teacher of filteredTeachers" class="dropdown-option"
                                    (click)="selectTeacher(teacher)">
                                    {{ getTeacherLabel(teacher) }}
                                </div>
                                <div *ngIf="filteredTeachers.length === 0" class="no-options">
                                    No teachers found
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Selected Teachers Section -->
            <div class="selected-teachers-section" *ngIf="selectedTeachers.length > 0">
                <div class="selected-schools-header">
                    Assigned teachers
                    <!-- <span class="schools-count">{{ selectedTeachers.length }} teachers assigned</span> -->
                </div>

                <div class="selected-schools-list">
                    <div *ngFor="let teacher of selectedTeachers; let i = index" class="selected-school-card">
                        <div class="school-info">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="school-name">{{ getTeacherLabel(teacher) }}</div>
                                <img src="assets/images/x-icon.svg" class="trash-icon" (click)="removeTeacher(i)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- No Teachers Message -->
            <div *ngIf="availableTeachers.length === 0 && selectedTeachers.length === 0" class="no-teachers-message">
                No teachers available for this school
            </div>
        </div>

        <div class="d-flex gap-4 justify-content-center" style="padding: 1rem;">
            <button type="button" class="cancel-button" (click)="onCancel()">
                Cancel
            </button>
            <button type="button" class="update-button" [disabled]="loading || selectedTeachers.length === 0"
                (click)="onSave()">
                {{ loading ? 'Saving...' : 'Save' }}
            </button>
        </div>
    </form>
</div>